export const iconFontAwesomeArrowsCaretRight = (
	<i className="fa-solid fa-caret-right"></i>
);
